import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

interface ITitle {
  isNew: boolean;
}

export const Title = ({ isNew }: ITitle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);

  return isNew ? (
    <Stack>
      <Typography variant='h3'>{dictionary.newPageTitle}</Typography>
      <Typography variant='body3'>{dictionary.newPageMessage}</Typography>
    </Stack>
  ) : (
    <Typography variant='h3'>{dictionary.yourOpinionIsImportant}</Typography>
  );
};
